/** Gap between the read-only preview and the action buttons. */
export const READ_ONLY_CODE_TABLE_ACTION_BAR_GAP = 4;

/** Height of the action button row (excluding gap above). Matches compact `h-7` buttons. */
export const READ_ONLY_CODE_TABLE_ACTION_BAR_HEIGHT = 28;

/** Total vertical space reserved below the preview content. */
export const READ_ONLY_CODE_TABLE_ACTION_BAR_RESERVED_HEIGHT =
  READ_ONLY_CODE_TABLE_ACTION_BAR_GAP + READ_ONLY_CODE_TABLE_ACTION_BAR_HEIGHT;
